import { useQuery } from '@tanstack/react-query';
import { BotsActivityTimeseriesResponse } from '../../../types/bots-activity/BotsActivityTimeseriesResponse';
import { getTimeseries } from '../../../services/bots-activity/BotsActivityService';
import { GET_BOTS_ACTIVITY_TIMESERIES } from '../../query/bots-activity/keys';

export const useGetBotsActivityTimeseries = (
  projectId: number | null,
  range: string,
  granularity: 'hour' | 'day' | 'week'
) => {
  const queryEnabled = !!projectId;

  const { data, isLoading, isError, refetch } = useQuery<BotsActivityTimeseriesResponse>({
    queryKey: [GET_BOTS_ACTIVITY_TIMESERIES, projectId, range, granularity],
    queryFn: () => getTimeseries(projectId!, range, granularity),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
  });

  return {
    data,
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
